import React from 'react';
import PropTypes from 'prop-types';
import PaymentMethodIcon from '../PayManually/PaymentMethodIcon';
import styles from './PaymentMethodButton.scss';
import { translate } from 'react-i18next';
import ExternalPaymentMethodIcon from '../PayManually/ExternalPaymentMethodIcon';
import { Text } from 'wix-style-react';

class PaymentMethodButton extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string,
    dataHook: PropTypes.string,
    onClick: PropTypes.func,
    svgUrl: PropTypes.string,
    t: PropTypes.func,
    title: PropTypes.string,
  };

  render() {
    const { type, onClick, dataHook } = this.props;
    const icon = this._getIcon();
    const text = this._getText();

    return (
      <button data-hook={dataHook} className={styles.wrapper} onClick={() => onClick(type)}>
        {icon}
        {text}
      </button>
    );
  }

  _getIcon() {
    const { type, svgUrl, title } = this.props;

    if (svgUrl) {
      return <ExternalPaymentMethodIcon svgUrl={svgUrl} alt={title} />;
    } else {
      return (
        <div>
          <PaymentMethodIcon type={type} />
        </div>
      );
    }
  }

  _getTextContent(str, fallback) {
    const { t } = this.props;
    const translated = t(str);

    if (translated === str) {
      return fallback;
    } else {
      return translated;
    }
  }

  _getText() {
    const { type, title } = this.props;

    return (
      <Text size="medium" weight="normal" className={styles.text}>
        {title || this._getTextContent(`phoneordering_checkout_${type}_label`, type)}
      </Text>
    );
  }
}

export default translate()(PaymentMethodButton);
